<mat-tab-group>
  <mat-tab label="Properties">
    <app-settings-properties></app-settings-properties>
  </mat-tab>
  <mat-tab label="Mappings">
    <app-settings-mappings></app-settings-mappings>
  </mat-tab>
</mat-tab-group>
